<template>
  <v-row>
    <v-col cols="12">
      <h4 class="title">
        {{ local.home.upcomingSessions.title }} ({{ upcomingSessions.totalCount }})
      </h4>
    </v-col>

    <template v-for="(item, index) in upcomingSessions.list">
      <div
        v-if="index < 4"
        :key="index"
        class="flex-grow-1 session-card-wrapper"
      >
        <session-card-info :session="item"></session-card-info>
      </div>
    </template>
    <div class="view-all-sessions-wrapper">
      <router-link
        :to="'/calendar'"
        class="view-all-sessions px-5"
      >
        <v-icon
          class="icon"
          color="var(--app-dark-primary-color)"
        >
          mdi-arrow-left
        </v-icon>
        <div class="my-4 all-sessions-text">
          {{ local.home.upcomingSessions.showAllSessions }}
        </div>
      </router-link>
    </div>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapLawsuitActions } = createNamespacedHelpers('LawsuitModule');

import SessionCardInfo from '../session-card-info';

export default {
  components: { SessionCardInfo },
  props: {},
  data() {
    return {
      loading: false,
      upcomingSessions: {
        list: [],
        totalCount: 0,
      },
      showAllSessionsModal: false,
    };
  },
  computed: {},
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapLawsuitActions(['getUpcomingSessions']),
    openAllSessionsModal() {
      this.showAllSessionsModal = true;
    },
    closeAllSessionsModal() {
      this.showAllSessionsModal = false;
    },
    loadData() {
      this.loading = true;
      this.getUpcomingSessions().then(({ data }) => {
        this.upcomingSessions = {
          list: data,
          totalCount: data && data.length ? data[0].totalCount : 0,
        };
      }).catch(() => { })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  color: var(--app-dark-primary-color);
  font-weight: bold;
  font-family: Almarai !important;
}

// var(--app-dark-primary-color) Dark Green (Black)
// #158e8d Dark Cyan
// var(--app-light-secondary-color) Extra Light Yellow
// #dbdbdb Extra Light Grey Yellow
// #A6B8BB Light Grey
// #6768B Grey
// #495057 Dark Grey

.session-card-wrapper {
  max-width: 30% !important;
}

.view-all-sessions-wrapper {
  display: flex;

  .view-all-sessions {
    min-height: 160px;
    color: var(--app-dark-primary-color);
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    background-color: var(--app-light-secondary-color);
    line-height: 3;
    font-size: 18px;
    flex: 1;

    .icon {
      font-size: 32px;
    }
    .all-sessions-text {
      max-width: 70%;
      line-height: 28px;
    }
  }
}
</style>
